import { render, staticRenderFns } from "./folder-list.vue?vue&type=template&id=0e000872&scoped=true&"
import script from "./folder-list.vue?vue&type=script&lang=ts&"
export * from "./folder-list.vue?vue&type=script&lang=ts&"
import style0 from "./folder-list.vue?vue&type=style&index=0&id=0e000872&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e000872",
  null
  
)

export default component.exports